import { Button, Form, Modal } from "react-bootstrap"
import React, { Component } from "react"

import { Empty } from "antd"
import { Link } from "react-router-dom"
import Loader from "../../components/common/Loader"
import Pagination from "react-js-pagination"
import Sidebar from "../../components/sidebar"
import Url from "../../services/BaseUrl"
import _ from "lodash"
import { _Api } from "../../services/Api"
import { notify } from "../../components/common/Toaster"
import siteSetting from "../../config/env/Index"

var farmmarketmarkers = []

class FarmerManagement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 2,
      farmerDetails: "",
      search: "",
      totalCount: 0,
      sortType: "",
      sortField: "",
      pageNo: 1,
      count: 10,
      loading: false,
      visible: false,
      isLoader: false,
      status: 1,
      logout: false,
    }
  }

  componentDidMount() {
    this.getFarmerDetails()
  }

  handlePageChange = (pageNo) =>
    this.setState({ loader: false, pageNo }, () => this.getFarmerDetails())

  handleSearch = (e) => {
    this.setState({ search: e.target.value })
    if (e.target.value.length > 2) {
      this.setState({ search: e.target.value }, () => this.getFarmerDetails())
    }
    if (e.target.value === "") {
      this.setState({ search: e.target.value }, () => this.getFarmerDetails())
    }
  }
  handleSort = (sortField) =>
    this.setState(
      {
        loader: false,
        sortField,
        sortType: this.state.sortType === 1 ? -1 : 1,
      },
      () => this.getFarmerDetails()
    )
  handleUserStatus = (e) =>
    this.setState(
      {
        loader: false,
        userStatus: this.state.userStatus === 0 ? 1 : 0,
      },
      () => this.getFarmerDetails()
    )

  getFarmerDetails = () => {
    let { search, count, pageNo, totalCount, sortField, sortType } = this.state
    let req = {
      search,
      sortType,
      sortField,
      pageNo,
      count,
    }

    this.setState({ isLoader: true })
    _Api(
      Url.SUPER_ADMIN_GET_USER.method,
      Url.SUPER_ADMIN_GET_USER.url,
      "",
      `?search=${req.search}&count=${req.count}&pageNo=${req.pageNo}&sortType=${req.sortType}&sortField=${req.sortField}`
    ).then((resp) => {
      this.setState({
        farmerDetails: resp.responseData.farmersInfo.driverInfo,
        totalCount: resp.responseData.farmersInfo.dataCount,
        isLoader: false,
      })
    })
  }

  handleOnChangeStatus = (id, status) => {
    let req = {
      userId: id,
      status,
    }
    _Api(
      Url.SUPER_ADMIN_CHANGE_STATUS.method,
      Url.SUPER_ADMIN_CHANGE_STATUS.url,
      req
    ).then((resp) => {
      notify("success", resp.responseData.message)
      this.setState({ visible: false })
      this.getFarmerDetails()
    })
  }

  //Show modal
  showModal = (id) => {
    this.setState({
      visible: true,
      selectedId: id,
    })
  }
  //Cancel modal
  handleCancel = () => {
    this.setState({ visible: false })
  }
  //admin active and inactive user
  handleAciveInactiveStatus = (e, id) => {
    let req = {
      userId: id,
      status: e.target.checked ? 0 : 1,
    }
    _Api(
      Url.SUPER_ADMIN_CHANGE_STATUS.method,
      Url.SUPER_ADMIN_CHANGE_STATUS.url,
      req
    )
      .then((resp) => {
        this.setState({ visible: false })

        if (resp.statusCode === 1) {
          notify("success", resp.responseData.message)

          this.getFarmerDetails()
        } else {
          this.setState({ loader: false })

          notify("error", resp.error.responseMessage)
        }
      })
      .catch((err) => {
        this.setState({ loader: false })

        notify("error", err.data.error.responseMessage)
      })
  }

  handleVerify = (e, id) => {
    let req = {
      userId: id,
      status: e.target.checked ? 3 : 4,
    }
    _Api(
      Url.SUPER_ADMIN_CHANGE_STATUS.method,
      Url.SUPER_ADMIN_CHANGE_STATUS.url,
      req
    )
      .then((resp) => {
        this.setState({ loader: false })
        this.setState({ visible: false })

        if (resp.statusCode === 1) {
          notify("success", resp.responseData.message)
          this.getFarmerDetails()
        }
      })
      .catch((err) => {
        this.setState({ loader: false })
        notify("error", err.data.error.responseMessage)
      })
  }

  render() {
    let {
      farmerDetails,
      pageNo,
      count,
      search,
      totalCount,
      sortField,
      sortType,
      visible,
      loading,
      status,
      isLoader,
    } = this.state
    return (
      <>
        <Sidebar />
        <div className="body_container">
          <div className="body_inner_wrapper">
            {/* {isLoader && <Loader />} */}
            <header className="header_content">
              {/*{isLoader && <Loader/>}*/}
              <p>Farmer Management</p>

              <div className="header_search ">
                <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback"></span>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    maxLength={30}
                    name="search"
                    value={search}
                    onChange={this.handleSearch}
                  />
                </div>
              </div>
              <div className="d-flex text-nowrap header_btn">
                <Link to="/farmermanagement/addfarmer" className="text-light">
                  <Button variant="warning">
                    <i class="fas fa-plus-circle"></i>
                    Add Farmer
                  </Button>
                </Link>
              </div>
            </header>

            <div className="main_content">
              <div class="table-responsive">
                <table class="table cm_bottom_space">
                  <thead>
                    <tr class="broder_top_0">
                      <th scope="col">S.No.</th>
                      <th
                        scope="col"
                        onClick={() => this.handleSort("firstName")}
                      >
                        Farmer Name
                        <i class="fas fa-sort text_dark ml-2 d-inline-block"></i>
                      </th>
                      {/*<th scope="col">Email</th>*/}
                      <th scope="col">Farm Name</th>
                      {/*<th scope="col">Total Order</th>*/}
                      <th scope="col">Commission(%)</th>
                      <th scope="col">Account Id</th>
                      <th scope="col">Verify</th>
                      <th scope="col">Inactive/Active</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {farmerDetails &&
                      farmerDetails.map((item, i) => (
                        <tr>
                          {/*<td>{i + 1}</td>*/}
                          <td>{count * (pageNo - 1) + (i + 1)}</td>

                          <td>
                            {item.firstName} {item.lastName}
                          </td>
                          {/*<td>{item.email}</td>*/}
                          <td>
                            {item.farmName == null ? "N/A" : item.farmName}
                          </td>
                          {/*<td>---</td>*/}
                          <td>
                            {item.commission == null ? "N/A" : item.commission}
                          </td>
                          <td>{item.accountId ? item.accountId : "N/A"}</td>
                          <td>
                            <div class="switch_wrapper">
                              <input
                                type="checkbox"
                                checked={item.isVarified === 1 ? false : true}
                                onChange={(e) => this.handleVerify(e, item._id)}
                              />
                              <span class="checkbox_swich"></span>
                            </div>
                          </td>
                          <td>
                            <div class="switch_wrapper">
                              <input
                                type="checkbox"
                                checked={item.status === 1 ? false : true}
                                onChange={(e) =>
                                  this.handleAciveInactiveStatus(e, item._id)
                                }
                              />
                              <span class="checkbox_swich"></span>
                            </div>
                          </td>
                          <td>
                            <div className="action_wrapper">
                              <span>
                                <Link
                                  to={`/farmermanagement/farmerdetails/${item._id}`}
                                >
                                  <i class="fas fa-eye"></i>
                                </Link>
                              </span>
                              <span>
                                <Link
                                  to={`/farmermanagement/editfrmermanagement/${item._id}`}
                                >
                                  <i class="fas fa-pen text-warning "></i>
                                </Link>
                              </span>
                              <span onClick={() => this.showModal(item._id)}>
                                <i className="fas fa-trash-alt text-danger"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {farmerDetails && farmerDetails.length ? (
                  ""
                ) : (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
              </div>
              {farmerDetails && farmerDetails.length ? (
                <div className="d-flex justify-content-end cm-pagination">
                  <Pagination
                    itemClassPrev={"prevClass"}
                    itemClassNext={"nextClass"}
                    activePage={this.state.pageNo}
                    itemsCountPerPage={this.state.count}
                    totalItemsCount={this.state.totalCount}
                    pageRangeDisplayed={3}
                    onChange={this.handlePageChange}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <Modal
          show={visible}
          onHide={this.handleCancel}
          className="cm_order_view dlt_item"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <img src={require("../../assets/img/Delete-Email.png")} />
            <br />
            <br />
            <p>Are you sure you want to delete this farmer?</p>
          </Modal.Body>
          <Modal.Footer>
            <div className="footer_btn_wrapper btn_nospace">
              <Button
                variant="warning"
                loading={loading}
                onClick={() =>
                  this.handleOnChangeStatus(this.state.selectedId, 2)
                }
              >
                Yes
              </Button>
              <Button variant="dark" onClick={this.handleCancel}>
                No
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}

export default FarmerManagement
